"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.ColumnSorting = void 0;
var _columnSorting = require("./columnSorting");
exports.PLUGIN_KEY = _columnSorting.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _columnSorting.PLUGIN_PRIORITY;
exports.ColumnSorting = _columnSorting.ColumnSorting;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/columnSorting/index.js
// module id = 509
// module chunks = 0